<template>
    <span v-if="type" class="instrument-logo">
        <img :src="logoUrl" :alt="type" />
    </span>
</template>

<script>
import { INSTRUMENT_TYPE } from '../../../business/const'

export default {
    name: 'InstrumentLogo',
    props: {
        type: {
            type: String,
            default: INSTRUMENT_TYPE.VITRO
        }
    },
    computed: {
        logoUrl() {
            const logos = {
                [INSTRUMENT_TYPE.GERI]: 'Geri.svg',
                [INSTRUMENT_TYPE.VITRO]: 'Es.svg',
                [INSTRUMENT_TYPE.MIRI]: 'Miri.svg'
            }
            return `/static/svg/instruments/${logos[this.type]}`
        }
    }
}
</script>

<style lang="scss" scoped>
.instrument-logo {
    img {
        width: 1.5rem;
        margin-right: 0.5rem;
    }
}
</style>
